import axios from 'axios'

const state = {
    leaves: {},
    isLoadingTable: false,
    showDeleteModal: false,
    leave: {}
}

const mutations = {
    getPaginatedLeaves(state,payload){
        state.isLoadingTable = true
        axios.get(`api/leaves/page=${payload.page}&pageSize=${payload.pageSize}/${payload.query}`).then(response=>{
            state.leaves = response.data
        }).catch(error=>{
            // eslint-disable-next-line no-console
            console.log(error)
        }).then(()=>{
            state.isLoadingTable = false
        })
    },
    openDeleteModal(state,payload){
        state.showDeleteModal = payload.showDeleteModal
        if(payload.leave){
            state.leave = payload.leave
        }else{
            state.leave = {}
        }
    }
}

const actions = {
    getPaginatedLeaves({commit},payload){
        commit('getPaginatedLeaves',payload)
    },
    openDeleteModal({commit},payload){
        commit('openDeleteModal', payload)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}